import { afterDidomiDisappeared } from '@src/common/analytics';
import { startABTest } from '@src/common/ab_tasty_generic_triggers';

// As Philipe advise, this should be moved to a JS file
function togglePopupAbTest() {
  const storeKey = 'team-lineup-popup-test';
  const $popup = $('.toggle-popup');

  const computeBtnSpacing = function () {
    const leftTabBtn = document.querySelector('.toggle a[data-params-slug="solo"]');
    const middleTabBtn = document.querySelector('.toggle a[data-params-slug="team"]');
    let leftSpace;
    if (!leftTabBtn || !middleTabBtn) {
      leftSpace = 0;
    } else {
      leftSpace = leftTabBtn.offsetWidth + (middleTabBtn.offsetWidth / 2);
    }
    $popup.css({ left: leftSpace, opacity: 1, transform: 'translateY(0)' });
  };

  const placePopup = function () {
    if (window.location.pathname.indexOf('/payment-methods/card/x-card') >= 0) return;
    $popup.css({ left: computeBtnSpacing() });
  };

  placePopup(); // place popup dynamically on first load.
  $(window).on('resize', placePopup); // replace it on resize.

  if (!localStorage.getItem(storeKey)) {
    $popup.delay(1500).fadeIn();
  }

  const closePopup = function (event) {
    event.preventDefault();
    $popup.hide();
    localStorage.setItem(storeKey, true);
  };

  const toggleLinetext = function (event) {
    const $tabBtn = $(this);
    const $textLine = $('.toggle-textline');
    if ($tabBtn.data('params-slug') == 'solo') {
      $textLine.show();
    } else {
      $textLine.hide();
    }
  };

  $('.open-team-tab').click(function () {
    $('.alt-page-tab[data-params-slug=team]').click();
    closePopup();
  });

  $('.alt-page-tab').click(function (event) {
    closePopup.call(this, event);
    toggleLinetext.call(this, event);
  });
  $popup.find('.close.btn').click(closePopup);
}
if (window.location.search.indexOf('select-toggle=team') < 0 && window.location.search.indexOf('select-toggle=creation') < 0) {
  afterDidomiDisappeared(togglePopupAbTest);
}

document.addEventListener('DOMContentLoaded', function (_event) {
  // Enable only for FR
  if ($('body').data('locale') == 'fr') {
    startABTest('pricing', 'a');
    if (window.location.search.indexOf('select-toggle=team') >= 0) {
      $('.ABTest-pricing-a').addClass('ABTest-hidden');
    }
  }
});
